import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useTypedSelector } from "../../hooks";

const PrivateRouteTerminal = ({ children, ...props }) => {
    const stateLogin = useTypedSelector(state => state.loginreducer);

    let usuarioLogado = stateLogin.Login !== "";
    let terminal = stateLogin.Terminal !== 0 && stateLogin.Terminal !== "";

    return (
        <Route {...props}>
            {usuarioLogado && terminal ? children : <Redirect to="/" />}
        </Route>
    );
};

export default PrivateRouteTerminal;
